module.exports = __webpack_public_path__ + "static/media/gratipay.424b1c0a.svg";